import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@mui/material';
import { dispatch, useSelector } from '../../../redux/store';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../components/table/DataGridTable';
import { accessVerify, capitalize, utcMoment } from '../../../utils/common';
import PermissionRequired from '../../errorPages/permissionRequired';
import { getAllPickmeFoodList } from '../../../redux/slices/saleRedux/pickmeFoodListRedux';
import { getPosDrawerList } from '../../../redux/slices/posRedux/posRedux';

export default function PosCashDrawerList() {
  const { themeStretch } = useSettings();
  const [pickmeFoodLists, setpickmeFoodLists] = useState([]);
  const [openPosCount, setOpenPosCount] = useState(0);

  const { posDrawerDataList, addData } = useSelector((state) => state.pos);

  useEffect(() => {
    dispatch(getPosDrawerList());
  }, []);

  useEffect(() => {
    setpickmeFoodLists(
      posDrawerDataList?.map((value) => {
        return {
          dateTime: utcMoment(value?.dateTime).format('YYYY-MM-DD'),
          day: utcMoment(value?.dateTime).format('YYYY-MM-DD'),
          time: utcMoment(value?.dateTime).format('HH:mm:ss'),
          ...value,
        };
      })
    );

    const openPosCount = posDrawerDataList?.filter((drawer) => drawer?.status === 'open')?.length;
    setOpenPosCount(openPosCount);
  }, [posDrawerDataList]);

  useEffect(() => {
    if (addData?.data) {
      dispatch(getAllPickmeFoodList());
    }
  }, [addData]);

  const columns = !pickmeFoodLists?.[0]
    ? []
    : Object.keys(pickmeFoodLists?.[0])
        .map((value) => {
          if (['dateTime'].includes(value)) {
            return {};
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        ?.filter((value) => value?.accessorKey);

  const [rowSelection, setRowSelection] = useState(false);

  return (
    <Page title={`POS Cash Drawers`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`POS Cash Drawers`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Drawers',
              href: '',
            },
            { name: `POS Cash Drawers` },
          ]}
          action={
            <Typography variant='h6' sx={{ color: 'red', fontWeight: '500' }}>
              Open Count:<b>{openPosCount}</b>
            </Typography>
          }
        />

        {accessVerify('FINANCE_POS_CASH_DRAWER_VIEW') ? (
          <DataGridTable
            name={'POS Cash Drawers'}
            data={pickmeFoodLists}
            column={columns}
            onRowClick={(row) => {}}
            isRowClickable={true}
            isLoading={false}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            enableRowSelection={false}
            enableRowActions={false}
            renderRowActionItems={(value, closeMenu) => []}
          />
        ) : (
          <PermissionRequired />
        )}
      </Container>
    </Page>
  );
}
